if (!customElements.get('filter-display-cta')) {
  class FilterDisplayCta extends HTMLElement {
    constructor() {
      super();
      this.filterShow = true;
      this.verticalFacets = document.querySelector('.facets-vertical > aside#main-collection-filters');
      this.addEventListener('click', () => {
        if (this.filterShow === true) {
          this.hideFilters();
        } else {
          this.showFilters();
        }
        this.filterShow = !this.filterShow;
      });
    }

    hideFilters() {
      if (this.verticalFacets) {
        this.verticalFacets.style.setProperty('--max-width', '0');
        this.verticalFacets.style.setProperty('--padding-right', '0');
        this.verticalFacets.style.setProperty('--height', '0');
        if (this.verticalFacets.classList.contains('is-active')) {
          this.verticalFacets.classList.remove('is-active');
          this.classList.remove('is-active');
        }
        const text = this.querySelector('p');
        text.textContent = 'Show filters';
      }
    }

    showFilters() {
      if (this.verticalFacets) {
        const scrollWidth = this.verticalFacets.scrollWidth + 30 + 'px';
        const scrollHeight = this.verticalFacets.scrollHeight + 'px';
        this.verticalFacets.style.setProperty('--max-width', scrollWidth);
        this.verticalFacets.style.setProperty('--padding-right', '3rem');
        this.verticalFacets.style.setProperty('--height', scrollHeight);
        if (!this.verticalFacets.classList.contains('is-active')) {
          this.verticalFacets.classList.add('is-active');
          this.classList.add('is-active');
        }
        const text = this.querySelector('p');
        text.textContent = 'Hide filters';
      }
    }
  }

  customElements.define('filter-display-cta', FilterDisplayCta);
}